// Cert-type identifiers as sent to / received from the backend
// (see App\Models\Certificate). Kept uppercase to match the values the
// certificate-types endpoint returns.
export const CertType = Object.freeze({
    DV: 'DV',
    OV: 'OV',
    EV: 'EV',
    DV_WILDCARD: 'DV_WILDCARD',
    OV_WILDCARD: 'OV_WILDCARD'
})

// Wildcard products cover a single common name plus its `*.` variant and
// have no multi-domain SKU, so they cannot be ordered as Multi-SAN (CIO-11850).
export const WILDCARD_CERT_TYPES = Object.freeze([
    CertType.DV_WILDCARD,
    CertType.OV_WILDCARD
])

// Order modes offered in the certificate creation modal.
export const CertificateMode = Object.freeze({
    MULTI_SAN: 'multi_san',
    BULK: 'bulk'
})
